import { Icon } from "@iconify/react/dist/iconify.js";
import ResponsePhrasesActions from "./ResponsePhrasesActions";

const ResponsePhrasesRow = ({ phrase }) => {
  // console.log(phrase);

  return (
    <tr>
      <td>
        <div className="d-flex align-items-center gap-2">
          <Icon
            icon="mdi:message-reply-text"
            width="20"
            className="text-primary"
          />
          <span>{phrase.frase}</span>
        </div>
      </td>
      <td>
        <span className="badge bg-info-600 text-white px-3 py-2">
          {phrase.valor}
        </span>
      </td>

      <td>
        <ResponsePhrasesActions phrase={phrase} />
      </td>
    </tr>
  );
};

export default ResponsePhrasesRow;
